import React from "react";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, setShowLogin } = useAuth();

  if (!isAuthenticated) {
    // open the login modal
    setShowLogin(true);
    return null;  // render nothing until they log in
  }

  return children;
}
